module.exports = __webpack_public_path__ + "img/home.6b65cea7.svg";